import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SubjectRelay } from '../../../shared/commands/subject-relay.class';

export type JobProgressDisplayCommand = {
	title: string;
	jobExecutionId: number;
	manualClose?: boolean;
	jobCompleteSubject?: Subject<boolean>;
	dialogClosedSubject?: Subject<void>;
}

@Component({
	selector: 'job-progress-dialog',
	templateUrl: 'job-progress-dialog.html',
	styleUrls: ['job-progress-dialog.css'],
})
export class JobProgressDialogComponent {
	// Gestion globale de la fenetre
	displayState$ = new Subject<boolean>();
	manualClose: boolean = true;
	allowClose: boolean = false;
	
	displayRules: JobProgressDisplayCommand | null = null;

	constructor(
	) {
		this.displayCommands$.subscribe(
			(command) => {
				this.displayRules = command;
				this.manualClose = !command || !!command.manualClose;
				this.displayState$.next(true);
			}
		);
		
		this.displayState$.subscribe(
			(display) => {
				if (!display) {
					this.allowClose = false;
					this.dialogClosed.emit();
					if (this.displayRules?.dialogClosedSubject) {
						this.displayRules.dialogClosedSubject.next();
					}
					this.displayRules = null;
				}
			}
		);
	}
	
	@Input() id: string = 'defaultJobProgressDialog';
	
	private displayCommands$ = new SubjectRelay<JobProgressDisplayCommand>();
	@Input() set displayCommands(obs: Observable<JobProgressDisplayCommand>) {
		this.displayCommands$.registerSource(obs);
	}
	
	@Output() jobCompleted = new EventEmitter<boolean>();
	@Output() dialogClosed = new EventEmitter<void>();
	
	onJobCompleted(succes: boolean) {
		if (!succes) {
			// Dans le cas d'un echec du batch, forcer le mode de fermeture manuelle
			this.manualClose = true;
		}
		
		this.allowClose = true;
		this.jobCompleted.emit(succes);
		
		if (this.displayRules?.jobCompleteSubject) {
			this.displayRules.jobCompleteSubject.next(succes);
		}
		
		if (!(this.manualClose)) {
			// Si la fermeture est automatique, attendre une seconde apres la
			// completion du job et fermer la boite de dialogue
			// (Cette seconde permet a l'utilisateur de voir le dernier message)
			setTimeout( //
				() => {
					this.displayState$.next(false);
				},
				1000
			);
		}
	}
	
	onManualCloseRequested() {
		this.displayState$.next(false);
	}
}